import { FunctionComponent } from "react";
import notificationStyles from "./styles/BadgeNotification.module.css";

const badgeStyles = {
  notification: notificationStyles,
} as const;

export type BadgeType = {
  className?: string;
  label?: string;
  showLabel?: boolean;

  /** Variant props */
  size?: "sm" | "md" | "lg";

  /** Custom props */
  style?: "notification";
};

const Badge: FunctionComponent<BadgeType> = ({
  className = "",
  size = "sm",
  label = "1",
  showLabel = true,
  style = "notification",
}) => {
  const styles = badgeStyles[style];
  
  const displayLabel = () => {
    const numLabel = Number(label);
    if (!isNaN(numLabel) && numLabel > 99) {
      return "99+";
    }
    return label;
  };

  return (
    <div
      className={[styles.root, className, "quill-ui-next-component"].join(" ")}
      data-size={size}
      data-empty-badge={!showLabel}
    >
      {showLabel && <b className={styles.label}>{displayLabel()}</b>}
    </div>
  );
};

export default Badge;
